module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-34.5b3c7f09.svg";